import { Card, Empty, Table } from "antd";
import Title from "antd/lib/typography/Title";
import dayjs from "dayjs";
import { Event, EventType, Location } from "interfaces/events";
import React from "react";
import { useHistory } from "react-router-dom";

interface Props {
  events: Event[];
  loading: boolean;
  locations: Location[];
  eventTypes: EventType[];
}

const UpcomingEvents: React.FC<Props> = ({ events, loading, locations, eventTypes }) => {
  const history = useHistory();

  const eventColumns = [
    {
      title: "Visningsnavn",
      dataIndex: "name",
      width: "35%",
      ellipsis: true,
    },
    {
      title: "Type",
      dataIndex: "event_type",
      width: "20%",
      ellipsis: true,
      render: (eventTypeId: number) => eventTypes.find(eventType => eventType.id === eventTypeId)?.title,
    },
    {
      title: "Dato",
      dataIndex: "start",
      render: (start: string) => dayjs(start).format("DD.MM.YYYY"),
      width: "12.5%",
      ellipsis: true,
    },
    {
      title: "Klokkeslett",
      dataIndex: "start",
      render: (start: string) => dayjs(start).format("HH:mm"),
      width: "12.5%",
      ellipsis: true,
    },
    {
      title: "Sted",
      dataIndex: "location",
      width: "10%",
      ellipsis: true,
      render: (locationId: number) =>
        locationId ? locations.find(location => location.id === locationId)?.name : "Ikke bestemt",
    },
    {
      title: "Påmeldte",
      dataIndex: "registrations",
      width: "10%",
      ellipsis: true,
      render: (registrations: number, record: unknown) => {
        const event = record as Event;
        return dayjs().isBefore(dayjs(event.open)) ? "Ikke åpnet" : `${registrations}/${event.seats}`;
      },
    },
  ];
  return (
    <>
      <Title level={5}>Kommende arrangementer</Title>
      <Card>
        <Table
          columns={eventColumns}
          dataSource={events}
          size="small"
          rowKey="id"
          onRow={(_record, rowKey) => ({
            onClick: () => {
              if (rowKey === undefined) return null;
              history.push(`/events/${events[rowKey].id}`);
            },
          })}
          locale={{
            emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Ingen kommende arrangementer" />,
          }}
          loading={loading}
        />
      </Card>
    </>
  );
};

export default UpcomingEvents;
